import { all } from "redux-saga/effects";
import {
  watchInitMediaLibraryPage,
  watchSelectCollection,
  watchAddCollection,
  watchDeleteCollection,
  watchUpdateCollection,
  watchDeleteCollectionUser,
  watchCreateOrUpdateCollectionUser,
  watchAddCollectionAssets,
  watchAddCollectionAssetsFromFeed,
  watchAddCollectionAssetsFromStock,
  watchDeleteCollectionAsset,
  watchDeleteCollectionAssets,
  watchUpdateCollectionAsset,
  watchShowCreatePost,
  watchFilterAssets,
  watchChangeAssetPagination,
  watchReloadTags,
  watchApplyBulkTags,
  watchBulkMoveAssets,
  watchActionsToTrackByType,
  watchGetAllCollectionAssets,
  watchReloadAssetCurrentPage,
  watchLoadCollection,
  watchDuplicateAssets,
} from "./mediaLibrarySagas";

import { contentLabelSagas } from "./contentLabelSagas";

import { inboxSagas } from "./inboxSagas";
import { conversationInboxSagas } from "./conversationInboxSagas";

import { watchGetAccounts } from "./skedCoreSagas";
import sourceMediaSagas from "./sourceMediaSagas";
import postsSagas from "./postsSagas";
import collaborationStatusSagas from "./collaborationStatusSagas";
import tagTemplatesSagas from "./tagTemplatesSagas";
import { postSaga } from "features/post";
import { planerPageSaga } from "pages/planner/__redux-model";
import { deepLinkPostSaga } from "features/post-deeplink";
import { postFormSagas } from "./postFormSagas";
import { watchSelectedAccountsBridgeRemoval } from "../entities/accounts/model/selected-accounts";
import { watchAccountCountsBridgeRemoval } from "../entities/accounts/model/counts";
import { watchMediaPickerModel } from "../features/media-library/components/media-picker/model";

export default function* rootSaga() {
  yield all([
    // Media Library Settings
    watchInitMediaLibraryPage(),
    watchLoadCollection(),
    watchSelectCollection(),
    watchAddCollection(),
    watchDeleteCollection(),
    watchUpdateCollection(),
    watchDeleteCollectionUser(),
    watchCreateOrUpdateCollectionUser(),
    watchAddCollectionAssets(),
    watchAddCollectionAssetsFromFeed(),
    watchAddCollectionAssetsFromStock(),
    watchDeleteCollectionAsset(),
    watchDeleteCollectionAssets(),
    watchUpdateCollectionAsset(),
    watchGetAllCollectionAssets(),
    watchReloadAssetCurrentPage(),
    watchShowCreatePost(),
    watchFilterAssets(),
    watchChangeAssetPagination(),
    watchReloadTags(),
    watchApplyBulkTags(),
    watchGetAccounts(),
    watchSelectedAccountsBridgeRemoval(),
    watchAccountCountsBridgeRemoval(),
    watchMediaPickerModel(),
    watchBulkMoveAssets(),
    watchDuplicateAssets(),
    watchActionsToTrackByType(),
    ...inboxSagas,
    ...conversationInboxSagas,
    sourceMediaSagas(),
    postsSagas(),
    collaborationStatusSagas(),
    tagTemplatesSagas(),
    // features
    postSaga(),
    deepLinkPostSaga(),
    // pages
    planerPageSaga(),
    postFormSagas(),
    // content labels
    ...contentLabelSagas,
  ]);
}
